/* eslint-disable */
export const checkItemRestriction = ({  
    customerLevel,
    itemType,
    itemSubType,
    restrictionConfig
}) => { 
    const formattedLevel = customerLevel ? `L${customerLevel}` : '';

    if (!restrictionConfig || !restrictionConfig[formattedLevel]) {
        return true;
    }

    const levelConfig = restrictionConfig[formattedLevel];
    const restrictionType = levelConfig?.type;
    const restrictionValues = levelConfig?.value || {};

    const normalizedItemType = (itemType || '')?.trim().toUpperCase();
    const normalizedItemSubType = (itemSubType || '')?.trim().toUpperCase();

    const hasItemType = Object.keys(restrictionValues)?.includes(normalizedItemType);
    
    const subTypeList = hasItemType ? restrictionValues[normalizedItemType] || [] : [];
    
    const matchesSubType = subTypeList?.includes("ALL") || subTypeList?.includes(normalizedItemSubType);

    let result = true;
    if (restrictionType === 1) {
        result = hasItemType && matchesSubType;
        console.log('Restriction type 1 (allowlist):', result ? 'ALLOWED' : 'RESTRICTED');
    } else if (restrictionType === 0) {
        result = !(hasItemType && matchesSubType);
    } else {
        console.log('Invalid restriction type, allowing by default');
    }
    return result;
};

export const handleItemRestriction = ({
    item,
    customerLevel,
    restrictionConfig,
    EnableCustomerLevelItemRestriction,
    ItemRestrictionCustomerLevels,
}) => {

    if (!item || (!item.itemTypeCode && !item.itemSubTypeCode)) {
        console.log('Item is empty or missing required properties, allowing by default');
        return true;
    }
    
    const itemType = item?.itemTypeCode || '';
    const itemSubType = item?.itemSubTypeCode || '';

    let isAllowed = true
    if(EnableCustomerLevelItemRestriction == '1' && ItemRestrictionCustomerLevels?.customerLevels?.includes(customerLevel)){
        isAllowed = checkItemRestriction({
            customerLevel,
            itemType,
            itemSubType,
            restrictionConfig,
        });
    }
    return isAllowed;
};
